<script>
	const routeContext = require('core/routeContext');

	module.exports = {
		components: {
			'weebly-iframe': require('components/weebly-iframe.vue').default
		},
		props: ['route-context'],
		data() {
			let rootPath = '/webinars';
			let path = (routeContext && routeContext.getParam('path')) || '';
			return {
				path,
				rootPath
			};
		},
		modelData: ['userContext'],
		computed: {
			eventData() {
				let path = this.path;
				let rootPath = this.rootPath;
				return { path: rootPath + path };
			}
		},
		mounted() {
			this.$watch('routeContext.path', function (value) {
				this.path = routeContext.getParam('path');
			});
		}
	};
</script>
<style lang="scss">
	.webinars {
		position: relative;
	}
</style>
<template>
	<main class="webinars">
		<weebly-iframe
			:path="path"
			:root-path="rootPath"
			:weebly-root-path="'/webinars.html'"
			:event-data="eventData"></weebly-iframe>
	</main>
</template>
